export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 0_00.04f41672.jpg";